import React, { useCallback, useEffect, useRef, useState} from "react";
import axios from "axios";
import "./styles.css";
import annotationPlugin from "chartjs-plugin-annotation";
import { Grid, CircularProgress,  Box } from "@mui/material";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  LineElement,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";


// pie charts
import { Typography } from '@mui/material';
import { ArcElement } from 'chart.js';
import AccordionComponent from "./components/AccordionComponent";
import SessionTrees from "./talkTreeShared/Tree/SessionTrees";
import { formatTimestampInRegionTimezone, getTimeZoneForRegion } from "./talkTreeShared/Tree/TimezoneUtility";
import ThreeFlowers from "./talkTreeShared/Tree/components/ThreeFlowers";
ChartJS.register(
  LineElement,
  BarElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler,
  annotationPlugin,
  ArcElement, 
  Tooltip,
  Legend,
  ChartDataLabels,
);


function TutorFeedbackPage() {
  const [availablePeriods, setAvailablePeriods] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState('');
  //states used to manage the data returned from the API
  const [data, setData] = useState([]);
  //User input states
  const [selectedDate, setSelectedDate] = useState("");
  const [transcriptSessionID, setTranscriptSessionID] = useState("");
  const [, setAuthError] = useState(false);
  const [regionList] = useState([]);
  const [tutorList, setTutorList] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [activeVisualization, setActiveVisualization] = useState('transcript');


  const [, setTutorTalkMoves] = useState([]);
  const [, setStudentTalkMoves] = useState([]);
  const talkMovesLabels = ['Content Knowledge', 'Learning Community', 'Rigorous Thinking'];
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [showGraphs, setShowGraphs] = useState(false);
  const [, setMathTopicsCovered] = useState('');
  const [, setFeedbackSessionHighlights] = useState('');
  const [, setStudentParticipation] = useState([]);
  const [analyticstSessionID, setAnalyticsSessionID] = useState('');
  const [tutorName, setTutorName] = useState("");
  const [mostRecentSession, setMostRecentSession] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [, setError] = useState(null);
  const initialSelectionDone = useRef(false);
  const [selectedTutorId, setSelectedTutorId] = useState('');
  const [previousSessionIds, setPreviousSessionIds] = useState([]);
  const [oldestSession, setOldestSession] = useState(null);
  const [inputType] = useState('');
  const [client, setClient] = useState();
  const [ analyticsNotFoundError, setAnalyticsNotFoundError] = useState(""); // analytics session not found
  const [, setAnalyticsFlag] = useState(false); // analytics service - session field empty before clicking view
  const [sessionDataCache, setSessionDataCache] = useState({
    transcript: null,
    analytics: null
  })
  const [dateWasChanged, setDateWasChanged] = useState(false);
  // functions to handle user input states
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setDateWasChanged(true);
    setSelectedDate(newDate);
    setSelectedPeriod('');
    setTranscriptSessionID('');
    setAnalyticsSessionID('');
    setShowGraphs(false);
    setPreviousSessionIds([]);
    setAvailablePeriods([]); 
    initialSelectionDone.current = true;
    apiCache.clear(); 
    // Reset data caches
    setSessionDataCache({
      transcript: null,
      analytics: null
    });
     if (selectedTutorId && selectedRegion) {
      // Small timeout to ensure state is updated
      setTimeout(() => {
        fetchAvailablePeriods();
      }, 200);
    }
  };

  const getDayKey = (timestamp) => {
    const date = new Date(timestamp);
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  };
// Pattern configuration object - easily modifiable
const PERIOD_PATTERNS = {
  anyInBrackets: {
    // match "[\.+]" pattern
    pattern: /\[([a-zA-Z0-9]+)\]/i,
    valueGroup: 1,  // Group containing the number
    displayGroup: 0, // Full match
    priority: 100
  },
  classInBrackets: {
    pattern: /\[(Class\s+(\d+))\]/i,  
    valueGroup: 2,  // Group containing just the number
    displayGroup: 1, // Group containing "Class X"
    priority: 90
  },
  ClassNStar: {
    pattern: /Class\s+(\d+)/i,  // "Class X" pattern
    valueGroup: 1,  // Group containing the number
    displayGroup: 0, // Full match
    priority: 80
  },
  periodXX: {
    // "(Period .*)"" pattern
    pattern: /\(Period\s+([a-zA-Z0-9]+)\)/i,
    valueGroup: 1,  // Group containing the number
    displayGroup: 0, // Full match
    priority: 70
  },
  NNN: {
    // "NNN" pattern
    pattern: /(\d\d\d)/i,
    valueGroup: 1,  // Group containing the number
    displayGroup: 0, // Full match
    priority: 50
  }
};

useEffect(() => {
    document.title = "Tutor Feedback";
  }, []);


const extractPeriodIdentifier = (sessionTitle) => {
  if (!sessionTitle) return null;
  
  // Try each pattern in order
  for (const [key, config] of Object.entries(PERIOD_PATTERNS)) {
    const match = sessionTitle.match(config.pattern);
    if (match) {
      // Extract both the value for comparison and the full display text
      const value = match[config.valueGroup]?.trim();
      const display = config.displayGroup === 0 ? match[0] : match[config.displayGroup];
      // console.log(`Period pattern with key: ${key} and pattern ${config.pattern} matched: title ${sessionTitle}, value ${value}, display ${display}`);
      
      if (value) {
        return {
          type: key,
          value: value,         // Just the number for exact comparison (e.g., "604")
          display: display,     // Full text for display (e.g., "Class 604")
          priority: config.priority
        };
      }
    }
  }
  
  return null;
};

const fetchCurrentAndPreviousSessions = async (selectedPeriodId, tutorId) => {
  if (!selectedPeriodId || !tutorId) {
    return { currentSession: null, previousSessions: [] };
  }

  try {
    const selectedPeriod = availablePeriods.find((p) => p.id === selectedPeriodId);
    if (!selectedPeriod) {
      return { currentSession: null, previousSessions: [] };
    }

    // Define sessionList based on available data
    const sessionList = data.map(session => ({
      sessionId: session.sessionId,
      startTime: session.sessionMetadata?.startTime || null,
      endTime: session.sessionMetadata?.endTime || null,
      title: session.sessionTitle || session.sessionMetadata?.title || 'Untitled Session'
    }))
    .filter(session => session.startTime !== null); // Filter out sessions with no startTime

    const selectedDate = new Date(selectedPeriod.startTime);
    const selectedSessionId = selectedPeriod.sessionId;
    
    // Extract period identifier from the selected session title
    const selectedSessionTitle = selectedPeriod.title;
    const selectedPeriodIdentifier = extractPeriodIdentifier(selectedSessionTitle);
    
    // If we couldn't identify a period pattern in the selected session, use time-based matching only
    const usePatternMatching = !!selectedPeriodIdentifier;
    
    // Calculate date range for the past sessions
    const endTime = selectedPeriod.startTime;
    const numPriorDays = 180;
    const numSessionsDisplayed = 6;
    const nDaysAgo = new Date(selectedDate);
    nDaysAgo.setDate(nDaysAgo.getDate() - numPriorDays);
    const startTime = nDaysAgo.getTime();

    // Filter sessions by date range
    const filteredSessions = sessionList.filter(session => {
      const sessionStartTime = session.startTime;
      return sessionStartTime >= startTime && sessionStartTime <= endTime;
    });

    // Sort sessions by date in descending order (newest first)
    const sortedSessions = filteredSessions.sort((a, b) => b.startTime - a.startTime);

    // Create a mapping of sessions by day
    const sessionsByDay = {};
    const sessionTimeWindow = 60; // minutes
    
    // Process each session to find matches
    sortedSessions.forEach((session) => {
      if (session.sessionId === selectedSessionId) return; // Skip current session
      
      const sessionDate = new Date(session.startTime);
      const dayKey = getDayKey(session.startTime);
      
      if (sessionDate.getTime() > selectedDate.getTime()) return;  // skip future sessions
      
      if (!sessionsByDay[dayKey]) {
        sessionsByDay[dayKey] = [];        // Initialize day if not exists
      }
      
      // Get period identifier for this session
      const sessionPeriodIdentifier = extractPeriodIdentifier(session.title);
      let matchScore = 0;
      let exactClassMatch = false;
      
      //Only match if the class numbers are exactly the same
      if (usePatternMatching && sessionPeriodIdentifier && selectedPeriodIdentifier) {
        // Check if values match exactly (the class numbers must be the same)
        if (sessionPeriodIdentifier.value === selectedPeriodIdentifier.value) {
          matchScore = sessionPeriodIdentifier.priority;
          exactClassMatch = true;
        }
      }
      else if (!usePatternMatching) {
         // Time-based matching as fallback or if pattern matching is disabled
         //if (matchScore === 0 && !exactClassMatch && !usePatternMatching) {
        //console.log("Falling back to time-based matching for session:", session.title);
        // Calculate time similarity
        const sessionTime = new Date(session.startTime);
        const selectedTime = new Date(selectedPeriod.startTime);
        
        // Compare hours and minutes only
        const sessionTimeMinutes = (sessionTime.getHours() * 60) + sessionTime.getMinutes();
        const selectedTimeMinutes = (selectedTime.getHours() * 60) + selectedTime.getMinutes();
        
        // Calculate the circular time difference (handling day wrap-around)
        let timeDiff = Math.abs(sessionTimeMinutes - selectedTimeMinutes);
        if (timeDiff > 720) { // More than 12 hours difference
          timeDiff = 1440 - timeDiff; // 24 hours = 1440 minutes
        }
        
        // Only consider sessions within time window and ONLY if we don't have pattern matches
        if (timeDiff <= sessionTimeWindow && (!usePatternMatching || !sessionPeriodIdentifier)) {
          // Convert time difference to a score (60 min = 0, 0 min = 50)
          matchScore = 50 - Math.floor((timeDiff / sessionTimeWindow) * 50);
        }
      }
      
      // Only add sessions with a positive match score
      if (matchScore > 0) {
        sessionsByDay[dayKey].push({
          ...session,
          matchScore,
          exactClassMatch,
          periodIdentifier: sessionPeriodIdentifier?.display || null,
          classNumber: sessionPeriodIdentifier?.value || null
        });
      }
    });
    
    // Create the week dates array
    const weekDates = [];
    for (let i = 0; i < numPriorDays; i++) {
      const date = new Date(selectedDate);
      date.setDate(date.getDate() - i);
      weekDates.push({
        date: date,
        dayKey: getDayKey(date.getTime())
      });
    }
    
    // Build the result array with strict session matching
    const priorSessions = [];
    
    // Add the current day's session first
    priorSessions.push({
      sessionId: selectedPeriod.sessionId,
      title: selectedPeriod.title,
      startTime: selectedPeriod.startTime,
      students: selectedPeriod.students || [],
      dayKey: weekDates[0].dayKey,
      date: weekDates[0].date,
      periodIdentifier: selectedPeriodIdentifier ? selectedPeriodIdentifier.display : null,
      classNumber: selectedPeriodIdentifier ? selectedPeriodIdentifier.value : null
    });
    
    const findBestMatchForDay = (dayKey, targetClassNumber) => {
      if (!sessionsByDay[dayKey] || sessionsByDay[dayKey].length === 0) {
        return null;
      }
      
      // First pass: Look for exact class matches
      if (targetClassNumber) {
        const exactMatches = sessionsByDay[dayKey].filter(s => 
          s.exactClassMatch && s.classNumber === targetClassNumber
        );
        
        if (exactMatches.length > 0) {
          // Sort by time (most recentfirst)
          return exactMatches.sort((a, b) => b.startTime - a.startTime)[0];
        }
      }
      
      // No exact matches found, use time-based matching as fallback ONLY IF no class number is available
      if (!targetClassNumber) {
        return sessionsByDay[dayKey].sort((a, b) => b.matchScore - a.matchScore)[0];
      }
      
      return null; // No suitable match found
    };
    
    // The target class number to match (from the selected session)
    const targetClassNumber = selectedPeriodIdentifier ? selectedPeriodIdentifier.value : null;
    
    // Process other days to find matching sessions
    for (let i = 1; i < numPriorDays && priorSessions.length < numSessionsDisplayed + 1; i++) {
      const dayKey = weekDates[i].dayKey;
      const dayDate = weekDates[i].date;
      
      const bestMatch = findBestMatchForDay(dayKey, targetClassNumber);
      
      if (bestMatch) {
        priorSessions.push({
          sessionId: bestMatch.sessionId,
          title: bestMatch.title || 'No Title',
          startTime: bestMatch.startTime,
          dayKey: dayKey,
          date: dayDate,
          matchScore: bestMatch.matchScore,
          periodIdentifier: bestMatch.periodIdentifier,
          classNumber: bestMatch.classNumber,
          exactClassMatch: bestMatch.exactClassMatch
        });
      }
    }

    return {
      currentSession: priorSessions[0],
      previousSessions: priorSessions.slice(1, numSessionsDisplayed+1)
    };   
  } catch (error) {
    console.error('Error fetching current and previous sessions:', error);
    return { currentSession: null, previousSessions: [] };
  }
};
  useEffect(() => {
    if (!initialSelectionDone.current && mostRecentSession && availablePeriods.length > 0) {
      const matchingPeriod = availablePeriods.find(
        period => period.sessionId === mostRecentSession.sessionId
      );
      
      if (matchingPeriod) {
        // Select this period
        setSelectedPeriod(matchingPeriod.id);
        
        // Set the session IDs for analytics and transcript
        setAnalyticsSessionID(mostRecentSession.sessionId);
        setTranscriptSessionID(mostRecentSession.sessionId);
          if (mostRecentSession.sessionId) {
            handleDataRetrievalClick();
            setShowGraphs(true);
          }

        initialSelectionDone.current = true;
      }
    }
  }, [mostRecentSession, availablePeriods]);

  const handlePeriodChange = (event) => {
    const selectedValue = event.target.value;
    const numPriorDays = 180;
    
    // First set the period without clearing other values
    setSelectedPeriod(selectedValue);
    
    if (selectedValue === '') {
      // Clear session IDs if no period is selected
      setAnalyticsSessionID('');
      setTranscriptSessionID('');
      setPreviousSessionIds([]);
      setShowGraphs(false);
      return;
    }
    
    // Set loading state before fetching data
    setAnalyticsLoading(true);
    
    const selectedPeriodObj = availablePeriods.find(p => p.id === selectedValue);
    
    if (selectedPeriodObj) {
      const sessionId = selectedPeriodObj.sessionId;
      
      // Set the session IDs for analytics and transcript
      setAnalyticsSessionID(sessionId);
      setTranscriptSessionID(sessionId);
      
      // Fetch the current and previous N days of sessions
      fetchCurrentAndPreviousSessions(selectedValue, selectedTutorId, numPriorDays)
        .then(result => {
          if (result.currentSession) {
            // Extract session IDs for previous sessions
            const previousSessionIds = result.previousSessions
              .filter(session => session && session.sessionId)
              .map(session => session.sessionId);
            
            setPreviousSessionIds(previousSessionIds);
            
            // Process the transcript data synchronously, one after another
            processTranscriptData(sessionId)
              .then(() => {
                // Process previous sessions sequentially to avoid race conditions
                const processSequentially = async (ids) => {
                  for (const id of ids) {
                    if (id && id !== sessionId) {
                      await processTranscriptData(id);
                    }
                  }
                };
                
                return processSequentially(previousSessionIds);
              })
              .then(() => {
                setActiveVisualization('talkTree');
                setShowGraphs(true);
                // Only call this after all processing is complete
                return handleTalkmoves();
              })
              .then(() => {
                setAnalyticsLoading(false);
              })
              .catch(error => {
                console.error("Error processing session data:", error);
                setShowGraphs(false);
                setAnalyticsLoading(false);
              });
          } else {
            setShowGraphs(false);
            setPreviousSessionIds([]);
            setAnalyticsLoading(false);
          }
        })
        .catch(error => {
          console.error("Error in session fetch:", error);
          setPreviousSessionIds([]); 
          setShowGraphs(false);
          setAnalyticsLoading(false);
        });
    } else {
      setAnalyticsSessionID('');
      setTranscriptSessionID('');
      setPreviousSessionIds([]);
      setShowGraphs(false);
      setAnalyticsLoading(false);
    }
  };



const latestSessionIdRef = useRef(transcriptSessionID);

useEffect(() => {
    latestSessionIdRef.current = transcriptSessionID;
}, [transcriptSessionID]);


const handleTalkmoves = async () => {
  if (transcriptSessionID === "") {
    setAnalyticsFlag(true);
    setAnalyticsNotFoundError("");
    return;
  }
  
  // Check if we have this data in cache
  if (sessionDataCache.analytics && 
    sessionDataCache.analytics.sessionId === transcriptSessionID) {
    // Use cached data
    return sessionDataCache.analytics.data;
  }
  
  const currentFetchSessionId = transcriptSessionID;
  setAnalyticsLoading(true);
  setStudentParticipation([]); 
  
  try {
    const sessionData = data.find(item => item.sessionId === currentFetchSessionId);
    
    if (!sessionData) {
      throw new Error("Session not found in existing data");
    }
    setAuthError(false);
    setAnalyticsFlag(false);
    setAnalyticsNotFoundError("");
    setAnalyticsSessionID(sessionData.sessionId);
    
    // Extract and process the data
    const extractCountsInOrder = (data, desiredOrder) => {
      return desiredOrder.map(label => {
        const category = data.find(item => item.label === label);
        return category ? category.count : 0;
      });
    };

    if (sessionData.metrics && sessionData.metrics.tutorTalkmoveCategories) {
      setTutorTalkMoves(extractCountsInOrder(sessionData.metrics.tutorTalkmoveCategories, talkMovesLabels));
    } else {
      setTutorTalkMoves([0, 0, 0]); // Default values if data is missing
    }
    
    if (sessionData.metrics && sessionData.metrics.studentTalkmoveCategories) {
      setStudentTalkMoves(extractCountsInOrder(sessionData.metrics.studentTalkmoveCategories, talkMovesLabels));
    } else {
      setStudentTalkMoves([0, 0, 0]); // Default values if data is missing
    }
    const topicTitle = sessionData.sessionMetadata?.content?.title || "No topic information available";
    setMathTopicsCovered(topicTitle);
      const generateFeedbackHighlights = (metrics) => {
      if (!metrics) return "No feedback data available.";
      
      const tutorMoveCount = metrics.tutorTalkMoves?.length || 0;
      const studentMoveCount = metrics.studentTalkMoves?.length || 0;
      
      // Prevent division by zero
      const participationRatio = metrics.tutorTalkTime && metrics.tutorTalkTime > 0 
        ? (metrics.studentTalkTime / metrics.tutorTalkTime).toFixed(2)
        : "N/A";
      
      return `This session had ${tutorMoveCount} tutor talk moves and ${studentMoveCount} student talk moves. ` +
             `The ratio of student to tutor participation was ${participationRatio}.`;
    };
    
    setFeedbackSessionHighlights(generateFeedbackHighlights(sessionData.metrics));
    
    // Extract student participation data with safety check
    if (sessionData.participantContributions && Array.isArray(sessionData.participantContributions)) {
      const newStudentParticipation = sessionData.participantContributions.filter(
        (entry) => entry.participantType === "student"
      );
      setStudentParticipation(newStudentParticipation);
    } else {
      setStudentParticipation([]);
    }
    
    // Update the cache
    setSessionDataCache(prev => ({
      ...prev,
      analytics: {
        sessionId: transcriptSessionID,
        data: [sessionData] // Match the array format from the original API response
      }
    }));
    
    setAnalyticsLoading(false);
    return [sessionData]; // Return in the same format as the original API call
  } catch (error) {
    console.error("Error fetching talk moves:", error);
    console.error("Error details:", error.message);
    setAnalyticsLoading(false);
    setAnalyticsFlag(true);
    setAnalyticsNotFoundError("The data could not be retrieved. Error: " + error.message);
    return null;   
  }
};


const handleDataRetrievalClick = async () => {
  if (!analyticstSessionID) {
    setAnalyticsFlag(true);
    setShowGraphs(false);
    return;
  }
  setActiveVisualization('talkTree');
  setAnalyticsLoading(true);
  setShowGraphs(false); // Hide graphs until data is ready
  
  try {
    // Call handleTalkmoves to get analytics data
    const analyticsData = await handleTalkmoves();
    
    if (!analyticsData) {
      throw new Error("Failed to retrieve analytics data");
    }
    
    // Process transcript data for current session
    const currentSessionData = await processTranscriptData(analyticstSessionID);
    
    if (!currentSessionData) {
      throw new Error("Failed to process transcript data for current session");
    }
    
    // Also process transcript data for previous sessions if any
    if (previousSessionIds.length > 0) {
      for (const id of previousSessionIds) {
        if (id && id !== analyticstSessionID) {
          await processTranscriptData(id);
        }
      }
    }
    
    setAnalyticsLoading(false);
    setActiveVisualization('talkTree');
    setShowGraphs(true);
  } catch (error) {  
    console.error("Error retrieving data:", error);
    setAnalyticsLoading(false);
    setShowGraphs(false);
  }
};

const handleButtonClick = async () => {
  setActiveVisualization("talkTree");
  
  // Only show graphs if we have a selected period
  if (selectedPeriod) {
    setShowGraphs(true);
    await handleDataRetrievalClick();
  } else {
    setShowGraphs(false);
  }
};

  
  const [, setUrlToken] = useState("");
  const [urlTutorId, setUrlTutorId] = useState("");

  // Helper function to calculate session duration in minutes
  const calculateSessionDuration = (metrics, sessionDiscourseHighlights) => {
    // Prefer metrics.sessionTime (seconds) converted to minutes
    if (metrics.sessionTime && metrics.sessionTime > 0) {
      return Math.round(metrics.sessionTime / 60);
    }
    
    // Fallback to discourse highlights
    if (sessionDiscourseHighlights.length > 0) {
      return Math.round(Math.max(...sessionDiscourseHighlights.map(h => h.end)) / 60);
    }
    
    // Final fallback
    return 0;
  };

  // Function to extract query parameters from the URL
const extractQueryParams = useCallback(async () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  // Extract token, tutorId, and client from URL
  const token = urlParams.get("token");
  const tutorId = urlParams.get("tutorId");
  const clientParam = urlParams.get("client");
  // retrieve an optional 'prior' parameter, used as a dateRangeLimit query parm to the tutorData call.
  const dateRangeLimit = urlParams.get("prior");

  if (!token || !tutorId) {
    setError("Missing URL parameters: token or tutorId");
    return null;
  }

  // Set client if present and equals TeachFX (case insensitive)
  if (clientParam && clientParam.toLowerCase() === "teachfx") {
    setClient("TeachFX");
  }
  // also check for a "demo" client
  else if (clientParam && clientParam.toLowerCase() === "demo") {
    setClient("Demo");
  }
  else {
    setClient("Generic");
  }
  // console.log("Client:", clientParam);
    
  setIsLoading(true);
  setError(null);

  mixpanel.identify(tutorId); 

  try {   
    // Fetch tutor data
    var apiURL = `https://api.hatproject.org/v1aux/analysis/tutorData?tutorId=${tutorId}&token=${token}`;
    //var apiURL = `https://api.dev.hatproject.org/v1aux/analysis/tutorData?tutorId=${tutorId}&token=${token}`;
    if (dateRangeLimit) {
      apiURL += `&dateRangeLimit=${dateRangeLimit}`;
    }

    const response = await axios.get(apiURL);

    //console.log("API Response:", response);
    const tutorDataArray = response.data;
    if (!tutorDataArray || tutorDataArray.length === 0) {
      setError("No tutor data available.");
      setIsLoading(false);
      return null;
    }  
    // Find the tutor in the participants list
    const tutor = tutorDataArray[0]?.sessionMetadata.participants.find(participant => participant.type === "tutor");
    setTutorName(tutor ? tutor.name : "Unknown Tutor");

    // Process and enrich the data
    const processedData = tutorDataArray.map(session => ({
      sessionId: session.sessionId,
      tutorId: session.tutorId,
      tutorName: tutorName,
      region: session.sessionMetadata.region || "",
      sessionTitle: session.sessionMetadata.title || "Untitled Session",
      startTime: session.sessionMetadata?.startTime || null,
      lessonSummary: session.sessionMetadata?.lessonSummary || "",
      subject: session.sessionMetadata?.subject || "",
      grade: session.sessionMetadata?.grade || "",
      endTime: session.sessionMetadata?.endTime || null,
      metrics: session.metrics || {},
      participants: session.sessionMetadata?.participants || [],
      participantContributions: session.participantContributions || [],
      sessionMetadata: session.sessionMetadata || {},
      sessionDiscourseHighlights: session.sessionDiscourseHighlights || [],
    }));
    // Make sure we have a valid region from the data
    const regionFromData = processedData[0]?.region || processedData[0]?.sessionMetadata?.region || "";
    if (regionFromData) {
      setSelectedRegion(regionFromData);
    }
    
    // Find the most recent session by comparing startTime values
    var mostRecent = null;
    if (processedData.length > 0) {
      const sortedData = [...processedData].sort((a, b) => b.startTime - a.startTime);
      mostRecent = sortedData[0];
      setMostRecentSession(mostRecent);
      
      // Find the oldest session (last item in the sorted array)
      const oldest = sortedData[sortedData.length - 1];
      setOldestSession(oldest);
      
      // Set the region and tutorId so the UI is updated
      setSelectedTutorId(tutorId);
      
      // Set the date based on the most recent session
      if (mostRecent.startTime) {
        const sessionDate = new Date(mostRecent.startTime);
        const formattedDate = sessionDate.toISOString().split('T')[0];
        setSelectedDate(formattedDate);
      }
      
      // Set the session ID for analytics
      setAnalyticsSessionID(mostRecent.sessionId);
      setTranscriptSessionID(mostRecent.sessionId);
    }
    // Update states
    setUrlToken(token);
    setUrlTutorId(tutorId);
    setData(processedData);
      
    setIsLoading(false);
       
    handleButtonClick();

    // record a mixpanel event
    mixpanel.track("TutorFeedbackPage_Loaded", {
      tutorId: tutorId,
      tutorRegion: regionFromData,
      sessionCount: processedData.length,
      viewedSessionId: mostRecent ? mostRecent.sessionId : null,
    });
    
    return {
      tutorId,
      tutorName,
      token,
      sessions: processedData,
      mostRecentSession: mostRecentSession
    };
  } catch (error) {
    console.error("Error fetching tutor data:", error);
    setError("Failed to fetch tutor data. Please check your credentials.");
    setIsLoading(false);
    return null;
  }
}, []);
useEffect(() => {
  extractQueryParams(); // Call the function automatically on page load
}, [extractQueryParams]);
  // Function to handle button click
useEffect(() => {
  // If we have a most recent session and available periods
  if (mostRecentSession && availablePeriods.length > 0) {
    // Find the period that matches the most recent session's ID
    const matchingPeriod = availablePeriods.find(
      period => period.sessionId === mostRecentSession.sessionId
    );
    
    if (matchingPeriod) {
      // Select this period
      setSelectedPeriod(matchingPeriod.id);
      
      // Set the session IDs for analytics and transcript
      setAnalyticsSessionID(mostRecentSession.sessionId);
      setTranscriptSessionID(mostRecentSession.sessionId);
      
      // Trigger data retrieval and visualization
      setTimeout(() => {
        handleDataRetrievalClick();
      }, 100); 
    }
  }
}, [mostRecentSession, availablePeriods]);

  const apiCache = new Map();
  const processTranscriptData = useCallback(async (transcriptSessionID) => {
    if (!transcriptSessionID) {
      setError("Session ID is required");
      return null;
    } 

    const cacheKey = `${transcriptSessionID}`;
    if (apiCache.has(cacheKey)) {
      return apiCache.get(cacheKey);
    }
  
    setIsLoading(true);
    setError(null);
  
    try {
      // Extract session data from the first item in the array
      const sessionData = data.find(item => item.sessionId === transcriptSessionID);
      if (!sessionData) {
        throw new Error(`Session ${transcriptSessionID} not found in existing data`);
      }  
    
      // Safely access properties with default values if missing
      const metrics = sessionData.metrics || {};
      const participantContributions = sessionData.participantContributions || [];
      const sessionMetadata = sessionData.sessionMetadata || {};
      const sessionDiscourseHighlights = sessionData.sessionDiscourseHighlights || [];
      
      // Check if sessionMetadata.highlights is an array before mapping
      const processedData = sessionDiscourseHighlights.map(highlight => ({
        // Keep all original fields
        category: highlight.category,
        end: highlight.end,
        noticingScore: highlight.noticingScore,
        participantId: highlight.participantId,
        segmentId: highlight.segmentId,
        speakerType: highlight.speakerType,
        start: highlight.start,
        text: highlight.text,
        type: highlight.type,
        
        // Add any additional derived fields needed for the tree
        statementId: highlight.segmentId,
        talkMoveCategory: highlight.category || '',
        talkMoveType: highlight.type || ''
      }));
      
      // determine activeParticipants as a subset of sessionMetadata.participants
      const participants = Array.isArray(sessionMetadata.participants) ? sessionMetadata.participants : [];
      const activeParticipants = participants
        .filter(participant =>
          participant.type === 'student' && // Ensure the participant type is "student"
          participantContributions.some(contributor => contributor.participantId === participant.id)
        )
        .map(participant => ({
          typeof: participant.type,
          id: participant.id,
          name: participant.name
        })); 
        
      // Calculate duration from metrics.sessionTime (preferred) or discourse highlights fallback
      const startTime = sessionMetadata.startTime || Date.now();
      const sessionDurationMinutes = calculateSessionDuration(metrics, sessionDiscourseHighlights);
      const realEndTime = startTime + (sessionDurationMinutes * 60 * 1000);
      
      const sessionMeta = {
        activeParticipants: activeParticipants,
        participants: participants,
        siteDirectors: sessionMetadata.siteDirectors || [],
        sessionId: sessionMetadata.sessionId || transcriptSessionID,
        title: sessionMetadata.title || "Untitled Session",
        tutorId: sessionMetadata.tutorId || '',
        startTime: startTime,
        endTime: realEndTime,
        region: sessionMetadata.region || '',
        lessonSummary: sessionMetadata?.lessonSummary || "",
        subject: sessionMetadata?.subject || "",
        grade: sessionMetadata?.grade || "",
      }   

      setSelectedRegion(sessionMeta.region);

      // Add metrics to the cache as well
      const enrichedData = {
        sessionMetadata: sessionMeta,
        processedData,
        metrics: {
          tutorMetrics: {
            talkMoves: metrics.tutorTalkMoves || [],
            talkMovesCategories: metrics.tutorTalkmoveCategories || [],
            utteranceCount: metrics.tutorUtteranceCount || 0,
            talkTime: metrics.tutorTalkTime || 0,
            mathTermCount: metrics.tutorMathTermCount || 0
          },
          studentMetrics: {
            talkMoves: metrics.studentTalkMoves || [],
            talkMovesCategories: metrics.studentTalkmoveCategories || [],
            utteranceCount: metrics.studentUtteranceCount || 0,
            talkTime: metrics.studentTalkTime || 0,
            mathTermCount: metrics.studentMathTermCount || 0
          },
          sessionMetrics: {
            sessionTime: sessionDurationMinutes * 60, // Convert back to seconds for compatibility
            sessionTimeMinutes: sessionDurationMinutes, // Add explicit minutes field
            totalUtterances: metrics.totalUtterances || 0,
            totalMathTermCount: metrics.totalMathTermCount || 0,
            longWaitTimes: metrics.longWaitTimes || 0,
            shortWaitTimes: metrics.shortWaitTimes || 0
          }
        }
      };
      // Store the enriched data in cache
      apiCache.set(cacheKey, enrichedData);
      setIsLoading(false);
      return enrichedData;
    } catch (error) {
      console.error("Error processing transcript data:", error);
      let errorMessage;
      if (error.response?.status === 404) {
        errorMessage = `Session ${transcriptSessionID} not found`;
      } else {
        errorMessage = `The data could not be retrieved. Error: ${error.message || 'unknown error'}`;
      }
      setError(errorMessage);
      setIsLoading(false);
      return null;
    }
  }, [data]);
  useEffect(() => {
    // If we have a most recent session and available periods
    if (mostRecentSession && availablePeriods.length > 0) {      
      // Find the period that matches the most recent session's ID
      const matchingPeriod = availablePeriods.find(
        period => period.sessionId === mostRecentSession.sessionId
      );
      
      if (matchingPeriod) {        
        // Select this period
        setSelectedPeriod(matchingPeriod.id);
        
        // Set the session IDs for analytics and transcript
        setAnalyticsSessionID(mostRecentSession.sessionId);
        setTranscriptSessionID(mostRecentSession.sessionId);
        
        // Trigger data retrieval and visualization after a short delay
        setTimeout(() => {
          // Only trigger if IDs are set
          if (mostRecentSession.sessionId) {
            handleDataRetrievalClick();
          }
        }, 500); // Increased delay to ensure state updates have completed
      } 
    }
  }, [mostRecentSession, availablePeriods]);
  const fetchAvailablePeriods = async () => {
    setAvailablePeriods([]);
    try {
      if (!selectedDate || !selectedRegion || !selectedTutorId) {
        console.log("Missing required data to fetch periods");
        return;
      }
  
      // Filter sessionList from extractQueryParams for the selected date
      let sessionsForDate = [];
      if (data && Array.isArray(data)) {
        sessionsForDate = data.filter((session) => {
          const sessionStartTime = session.startTime;
          if (!sessionStartTime) return false;
  
          // Convert session timestamp to a date string in the local timezone of the region
          const sessionDate = new Date(sessionStartTime);
          const sessionDateString = formatDateToYYYYMMDD(sessionDate, selectedRegion);
          return sessionDateString === selectedDate;
        });
      }
  
      if (sessionsForDate.length > 0) {
        // Create period options based on filtered sessions
        const periods = sessionsForDate.map((session) => {
          const startTime = session.startTime ? new Date(session.startTime) : null;
          if (!startTime || isNaN(startTime.getTime())) {
            console.error("Invalid session start time:", session.startTime);
            return null;
          }
  
          const sessionTitle = session.sessionTitle || "No Title Available";
          
          // Extract student information from participants including both ID and name
          const studentParticipants = (session.sessionMetadata?.participants || [])
            .filter((p) => p.type === "student")
            .map((p) => ({
              id: p.id,
              name: p.name || p.id // Use name if available, fallback to ID
            }));
          
          // Keep the IDs for backward compatibility
          const studentIds = studentParticipants.map(p => p.id);
  
          const formattedTime = formatTimestampInRegionTimezone(startTime.getTime(), selectedRegion);
  
          return {
            id: `${session.sessionId}_${startTime.getTime()}`,
            label: formattedTime,
            sessionId: session.sessionId,
            startTime: startTime.getTime(),
            title: sessionTitle,
            students: TutorFeedbackPage ? studentParticipants.map(p => p.name) : studentIds,
            studentDetails: studentParticipants // Keep full student details for reference
          };
        });
  
        const sortedPeriods = periods.filter(Boolean).sort((a, b) => a.startTime - b.startTime);
        setAvailablePeriods(sortedPeriods);
  
        if (!dateWasChanged && !initialSelectionDone.current && sortedPeriods.length > 0) {
          // console.log("Date was changed - waiting for user selection");
          setDateWasChanged(false);
        } else if (selectedPeriod === "" && !initialSelectionDone.current) {
          const mostRecentPeriod = sortedPeriods[sortedPeriods.length - 1];
          setSelectedPeriod(mostRecentPeriod.id);
          setTranscriptSessionID(mostRecentPeriod.sessionId);
          setAnalyticsSessionID(mostRecentPeriod.sessionId);
          setActiveVisualization('talkTree');
          setTimeout(() => {
            setShowGraphs(true);
            handleDataRetrievalClick();
          }, 300);
        }
      } else {
        console.log("No sessions found for the selected date:", selectedDate);
        setSelectedPeriod("");
        setTranscriptSessionID("");
        setAnalyticsSessionID("");
        setShowGraphs(false); 
        setDateWasChanged(false);
      }
    } catch (error) {
      console.error("Error in fetchAvailablePeriods:", error);
      setSelectedPeriod("");
      setTranscriptSessionID("");
      setAnalyticsSessionID("");
      setShowGraphs(false); 
    }
  };

  
  // Helper function to format date to YYYY-MM-DD in the region's timezone
  const formatDateToYYYYMMDD = (date, region) => {
    if (!date) return "";
    
    try {
      // Get the timezone for the region
      const timezone = getTimeZoneForRegion(region);
      
      // Format the date in the region's timezone
      const options = { 
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };
      
      const formattedDate = new Intl.DateTimeFormat('en-US', options)
        .format(date)
        .split('/')
        .map(part => part.padStart(2, '0'));
      
      // Convert from MM/DD/YYYY to YYYY-MM-DD
      return `${formattedDate[2]}-${formattedDate[0]}-${formattedDate[1]}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      
      // Fallback to UTC formatting
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  };
  

  useEffect(() => {
    // Clear any existing timeout to prevent race conditions
    const timeoutId = setTimeout(() => {
      if (selectedTutorId && selectedDate && selectedRegion) {
        // console.log("Detected changes in tutor/date/region - fetching periods");
        fetchAvailablePeriods();
      }
    }, 200); // Small timeout to batch multiple state changes
    
    return () => clearTimeout(timeoutId);
  }, [selectedTutorId, selectedDate, selectedRegion]);


return (
  <div style={{ 
    display: "flex", 
    flexDirection: "column", 
    minHeight: "100vh",
  }}>
    <div style={{ 
      flex: 1, 
      padding: "30px", 
      backgroundColor: "#f8fafc", 
      overflowX: "hidden",
      backgroundImage: "linear-gradient(to bottom, #f8fafc, #f1f5f9)"
    }}>
      
      {/* Show loading animation when data is loading */}
      {(isLoading || !data.length) ? (
        <Box 
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
            width: '100%'
          }}
        >
          <CircularProgress size={60} thickness={4} />
          <Typography variant="h6" sx={{ mt: 3, fontWeight: 500, color: '#3a3a3a' }}>
            Loading your tutoring data...
          </Typography>
        </Box>
      ) : (
        <>
          {/* Only show AccordionComponent when not loading */}
          <AccordionComponent
            inputType={inputType}
            transcriptSessionID={transcriptSessionID}
            setTranscriptSessionID={setTranscriptSessionID}
            selectedRegion={selectedRegion}
            setSelectedRegion={setSelectedRegion} 
            regionList={regionList}
            tutorList={tutorList}
            setTutorList={setTutorList}
            setSelectedTutorId={setSelectedTutorId}
            handleDateChange={handleDateChange}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedTutorId={selectedTutorId}
            availablePeriods={availablePeriods}
            selectedPeriod={selectedPeriod}
            setAvailablePeriods={setAvailablePeriods}
            fetchAvailablePeriods={fetchAvailablePeriods}
            handlePeriodChange={handlePeriodChange}
            setSelectedPeriod={setSelectedPeriod}
            isTutorFeedbackPage={true} 
            urlTutorId={urlTutorId} 
            tutorName={tutorName}
            client={client}
            mostRecentSession={mostRecentSession}
            oldestSession={oldestSession} 
            handleDataRetrievalClick={handleDataRetrievalClick}
            sessionData={data.find(item => item.sessionId === (selectedPeriod ? availablePeriods.find(p => p.id === selectedPeriod)?.sessionId : null))}

          />
          
          {/* Only show visualization section when data is fully loaded */}
          <div style={{
            background: "white",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            padding: "5px",
            marginTop: "20px"
          }}>
            <Grid container spacing={2} style={{ marginBottom: '0px', justifyContent: "flex-start", alignItems: "center" }}>
              <Grid item>
                <Typography variant="body1" style={{ marginLeft: "10px", fontSize: "1.5rem" }}>
                  Student Talk Trees
                </Typography>
              </Grid>
            </Grid>
            
            {/* Talk Tree Visualization */}
            {activeVisualization === 'talkTree' && (
              <>
                {analyticsLoading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px', flexDirection: 'column' }}>
                    <CircularProgress size={40} sx={{ mb: 2 }} />
                    <Typography variant="subtitle1">
                      Loading analytics data...
                    </Typography>
                  </Box>
                ) : (
                  <div>
                    {analyticsNotFoundError && (
                      <Grid container spacing={2} alignItems="center" style={{ padding: 10 }}>
                        <p style={{ color: 'red' }}>{analyticsNotFoundError}</p>
                      </Grid>
                    )}
                    {selectedPeriod && analyticstSessionID && showGraphs && !analyticsLoading && (

                      <div style={{ padding: 10 }}>
                        <ThreeFlowers/>
                        {analyticstSessionID && (
                          <SessionTrees
                            processTranscriptData={processTranscriptData}
                            analyticsSessionID={analyticstSessionID}
                            previousSessionIds={previousSessionIds}
                            isTutorFeedbackPage={true}
                            region={selectedRegion}
                            key={`${analyticstSessionID}-${selectedPeriod}`} 
                            client={client}
                            /> 
                        )} 
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  </div>
);
}


export default TutorFeedbackPage;

